module.exports = __webpack_public_path__ + "img/figma.3d05a5c2.svg";